<template>
	<div class="app-item">
		<template v-if='item.status===2'>
			<template v-if='user.login_status===2'>
				<template v-if='$config.wx.isWXMini'>
					<div class="miniitem" @click='handle_wxmini'></div>
				</template>
				<template v-else>
					<wx-open-launch-weapp :appid="item.appId" :path="`${item.url}?mazid=${user.mazId}`" v-if='user.login_status===2'>
						<script type="text/wxtag-template"><button style='display:inline-block;position:absolute;width:100%;height:100%;'>跳转</button></script>
					</wx-open-launch-weapp>
				</template>
			</template>
			<div @click='handle_login'>
				<van-image :src='item.icon'></van-image>
				<div class="text">{{item.name}}</div>
			</div>
		</template>
		<template v-else>
			<div @click='handle_tip'>
				<van-image :src='item.icon'></van-image>
				<div class="text">{{item.name}}</div>
			</div>
		</template>
	</div>
</template>
<script>
	export default {
		props: ["item"],
		data() {
			return {
				user: this.$config.userinfo,
			};
		},
		methods: {
			handle_tip() {
				this.$alert("该应用正在筹备，谢谢关注！");
			},
			handle_wxmini() {
				var item = this.item;
				var url = `/pages/redirect/index?mid=${item.id}&appid=${item.appId}&url=${item.url}&t=${item.name}&logo=${item.icon}`;
				wx.miniProgram.navigateTo({
					url: url,
				});
			},
			handle_login() {
				if (this.$config.wx.isWXMini) {
					wx.miniProgram.redirectTo({
						url: "/pages/oauth/index?source=/pages/home/index",
					});
				} else {
					this.$login();
				}
			},
		},
	};
</script>